// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mgh8H","delete":"styles_delete__2V4Wu","update":"styles_update__mMfHh","add":"styles_add__2pekc"};